/**
 * API Key Credential Integration Types
 */
export var ApiKeyCredentialIntegrationType;
(function (ApiKeyCredentialIntegrationType) {
    ApiKeyCredentialIntegrationType["BUILDIUM"] = "BUILDIUM";
    ApiKeyCredentialIntegrationType["SHOWMOJO"] = "SHOWMOJO";
    ApiKeyCredentialIntegrationType["RENTVINE"] = "RENTVINE";
    ApiKeyCredentialIntegrationType["TENANT_TURNER"] = "TENANT_TURNER";
    ApiKeyCredentialIntegrationType["HUBSPOT"] = "HUBSPOT";
    ApiKeyCredentialIntegrationType["DOORLOOP"] = "DOORLOOP";
    // Add other API key-based integrations here
})(ApiKeyCredentialIntegrationType || (ApiKeyCredentialIntegrationType = {}));
//# sourceMappingURL=api-key-credential-integration-type.js.map